import useLang from "hooks/useLang";
import { useEffect } from "react";
import { Container, Row, Col, Tab, Accordion } from "react-bootstrap";
import barcode from "../../assets/images/services/barcode-exemption.jpeg"
import SideBar from "components/our-services/SideBar";

const ExemptionPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const { lang } = useLang();
  
  return (
    <Container className="text-muted" style={{ paddingTop: "2rem", marginBottom: "50px" }}>
      <h2>{lang.services.lists.list_11.title}</h2>
      <Tab.Container id="exemption-services" defaultActiveKey="first">
        <Row>
          <Row>
            <Col>
              {lang.services.lists.list_11.paragraphs.map(l => <p>{l}</p>)}
              <Accordion defaultActiveKey={["0"]}>
                {lang.services.lists.list_11.accordion.map(l => {
                  return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                    <Accordion.Header>{l.header}</Accordion.Header>
                    <Accordion.Body>{l.body}</Accordion.Body>
                  </Accordion.Item>
                })}
              </Accordion>
              <p style={{ marginTop: "20px" }}>
                {lang.services.lists.list_11.why_us}
              </p>
              <Accordion defaultActiveKey={["0"]}>
                {lang.services.lists.list_11.accordion_why.map(l => {
                  return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                    <Accordion.Header>{l.header}</Accordion.Header>
                    <Accordion.Body>{l.body}</Accordion.Body>
                  </Accordion.Item>
                })}
              </Accordion>
            </Col>
            <SideBar barcode={barcode}/>
          </Row>
        </Row>
      </Tab.Container>
    </Container>
  );
};

export default ExemptionPage;
